import { useUserRole } from "@/hooks/useUserRole"
import i18n from "@/i18n"
import { setBranch } from "@/store/BranchSlice"
import { ProductBranch } from "@/types/globalTypes"
import { useTranslation } from "react-i18next"


import { IoMdArrowRoundBack, IoMdArrowRoundForward, IoMdCheckmark } from "react-icons/io"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
type branchesModal = {
    setBranchModalOpen: (open: boolean) => void
    branches: ProductBranch[]
    setSelectedBranch: (branch: ProductBranch) => void
    selectedBranch: ProductBranch | null
}

export default function CashierBranchesModal({ setBranchModalOpen, branches, setSelectedBranch, selectedBranch }: branchesModal) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isCashier, isWaiter } = useUserRole()
 
    


    return (
        <>
            <div className="fixed inset-0 -top-10 z-[9999] bg-black bg-opacity-50 flex items-center justify-center">
                <div className="bg-white px-2 py-4 rounded-lg  ">
                    <div className="flex flex-col gap-3 max-h-[80vh]  min-w-[75vw] md:min-w-[50vw] lg:min-w-[30vw] px-5 overflow-auto">
                        <h3 className="my-btn text-center font-bold md:text-lg">{t("cashierBranchModal.title")}</h3>
                        <Link
                            to={!isCashier && !isWaiter ? "/dashboard" : "/orders"}
                            className="flex size-fit items-center gap-2 rounded-md p-2 duration-150  hover:bg-black/10"
                        >
                            {(i18n.language === "ar" ? <IoMdArrowRoundForward /> : <IoMdArrowRoundBack />)}

                            <span className="text-lg font-semibold text-sidebar">
                                {!isCashier && !isWaiter ? t("cashierBranchModal.back") : t("cashierBranchModal.goToOrders")}
                            </span>
                        </Link>
                        <div className="flex flex-col gap-5 ">
                            {branches?.map((branch) => (
                                <div
                                    onClick={() => {
                                        if (branch.availability !== 0) return
                                        setSelectedBranch(branch)
                                    }}
                                    key={branch._id}
                                    className={`border-2 whitespace-nowrap flex items-center ${branch.availability !== 0 ? " text-gray-400 cursor-not-allowed" : "cursor-pointer"} justify-between gap-2 text-lg font-bold ${selectedBranch?._id === branch._id ? "border-sidebar text-sidebar" : "border-gray-300 text-black"} px-5 py-5 rounded-md `} >
                                    {t(branch.nameEN, branch.nameAR)}
                                    {selectedBranch?._id === branch._id && <span className="text-xl p-1 border-2  text-skyblue bg-sidebar rounded-full"><IoMdCheckmark /></span>}
                                    {branch.availability !== 0 && <span className="md:text-[15px] text-[12px] border-red-600 opacity-100 border border-red rounded-md px-2 font-normal text-red-600">{t("cashierBranchModal.notWorking")}</span>}
                                </div>
                            ))}
                        </div>
                        <button disabled={selectedBranch === null} onClick={() => {
                            if (selectedBranch) {
                                dispatch(setBranch(selectedBranch))
                                setBranchModalOpen(false)
                            }
                        }} className="disabled:bg-gray-500 my-btn text-lg font-bold">{t("cashierBranchModal.selectBranch")}</button>
                    </div>
                </div>

            </div >



        </>
    )
}
